import { IMinUserDepricated } from "@mctypes/global.types";
import React from "react";
import Avatar from "../Avatar";

const UserWithAvatar: React.FC<{
  user: IMinUserDepricated;
  height?: string;
}> = ({ user, height }) => {
  return (
    <div className="d-flex">
      <Avatar id={user._id} name={user.name} size={height} />
      <p>{user.name}</p>
    </div>
  );
};

export default UserWithAvatar;
